<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('products.productPrices.form.price')"
            is-required
            :error="errors.price"
        >
            <DInputGroup>
                <DInputGroupText
                    v-if="currency"
                    :value="currency"
                />
                <DInput
                    id="price"
                    v-model="form.price"
                    :placeholder="__('products.productPrices.form.price')"
                    :is-valid="isFormFieldValid('price')"
                    maxlength="13"
                />
            </DInputGroup>
        </DFormRow>
        <DFormRow
            :label="__('products.productPrices.form.third_party_cost')"
            is-required
            :error="errors.third_party_cost"
        >
            <DInputGroup>
                <DInputGroupText
                    v-if="currency"
                    :value="currency"
                />
                <DInput
                    id="third_party_cost"
                    v-model="form.third_party_cost"
                    :placeholder="__('products.productPrices.form.third_party_cost')"
                    :is-valid="isFormFieldValid('third_party_cost')"
                    maxlength="13"
                />
            </DInputGroup>
        </DFormRow>
        <DFormRow
            v-if="productPlan.runtime !== 'one_time'"
            :label="__('products.productPrices.form.billing_cycle')"
            is-required
            :error="errors.billing_cycle"
        >
            <DSelect
                id="billing_cycle"
                v-model="form.billing_cycle"
                :options="billingCycles"
                :placeholder="__('products.productPrices.form.billing_cycle')"
                :is-valid="isFormFieldValid('billing_cycle')"
            />
        </DFormRow>
        <DFormRow
            v-if="productPlan.runtime !== 'one_time'"
            :label="__('products.productPrices.form.setup_fee')"
            is-required
            :error="errors.setup_fee"
        >
            <DInputGroup>
                <DInputGroupText
                    v-if="currency"
                    :value="currency"
                />
                <DInput
                    id="setup_fee"
                    v-model="form.setup_fee"
                    :placeholder="__('products.productPrices.form.setup_fee')"
                    :is-valid="isFormFieldValid('setup_fee')"
                    maxlength="13"
                />
            </DInputGroup>
        </DFormRow>
        <DFormRow
            v-if="productPlan.runtime !== 'one_time'"
            :label="__('products.productPrices.form.valid_from')"
            is-required
            :error="errors.valid_from_month"
        >
            <DInput
                id="valid_from_month"
                v-model="form.valid_from_month"
                :placeholder="__('products.productPrices.form.valid_from')"
                type="number"
                :is-valid="isFormFieldValid('valid_from_month')"
                min="1"
                max="32767"
            />
        </DFormRow>
        <DFormRow
            v-if="productPlan.runtime !== 'one_time'"
            :label="__('products.productPrices.form.contract_term')"
            is-required
            :error="errors.contract_term"
        >
            <DInput
                id="contract_term"
                v-model="form.contract_term"
                :placeholder="__('products.productPrices.form.contract_term')"
                type="number"
                :is-valid="isFormFieldValid('contract_term')"
                min="0"
                max="127"
            />
        </DFormRow>
        <DFormRow
            v-if="productPlan.runtime !== 'one_time'"
            :label="__('products.productPrices.form.contract_term_unit')"
            is-required
            :error="errors.contract_term_unit"
        >
            <DSelect
                id="contract_term_unit"
                v-model="form.contract_term_unit"
                :options="contractTermUnits"
                :placeholder="__('products.productPrices.form.contract_term_unit')"
                :is-valid="isFormFieldValid('contract_term_unit')"
            />
        </DFormRow>
        <DFormRow
            v-if="productPlan.runtime !== 'one_time'"
            :label="__('products.productPrices.form.notice_period')"
            is-required
            :error="errors.notice_period"
        >
            <DInput
                id="notice_period"
                v-model="form.notice_period"
                :placeholder="__('products.productPrices.form.notice_period')"
                type="number"
                :is-valid="isFormFieldValid('notice_period')"
                min="0"
                max="127"
            />
        </DFormRow>
        <DFormRow
            v-if="productPlan.runtime !== 'one_time'"
            :label="__('products.productPrices.form.notice_period_unit')"
            is-required
            :error="errors.notice_period_unit"
        >
            <DSelect
                id="notice_period_unit"
                v-model="form.notice_period_unit"
                :options="contractTermUnits"
                :placeholder="__('products.productPrices.form.notice_period_unit')"
                :is-valid="isFormFieldValid('notice_period_unit')"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPrices.form.discount_name')"
            :error="errors.discount_name"
        >
            <DInput
                id="discount_name"
                v-model="form.discount_name"
                :placeholder="__('products.productPrices.form.discount_name')"
                :is-valid="isFormFieldValid('discount_name')"
                maxlength="32"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPrices.form.discount')"
            :error="errors.discount_value"
        >
            <DInputGroup>
                <DInputGroupText
                    v-if="currency && form.discount_type !== 'percentage'"
                    :value="currency"
                />
                <DInput
                    id="discount_value"
                    v-model="form.discount_value"
                    :placeholder="__('products.productPrices.form.discount')"
                    type="number"
                    :is-valid="isFormFieldValid('discount_value')"
                    min="0"
                />
            </DInputGroup>
        </DFormRow>
        <DFormRow
            :label="__('products.productPrices.form.discount_type')"
            :error="errors.discount_type"
        >
            <DSelect
                id="discount_type"
                v-model="form.discount_type"
                :options="discountTypes"
                :placeholder="__('products.productPrices.form.discount_type')"
                :is-valid="isFormFieldValid('discount_type')"
            />
        </DFormRow>

        <DFormControls
            v-model="form.activity_log_comment"
            :cancel-route="isAddon === false ? $route('products.products.show', {product: productId}) : $route('products.product-addons.show', {product: productId})"
            :dirty="form.isDirty"
            :show-change-reason-input="true"
            @submit="submitForm"
        />
    </DForm>
    <DModal
        :show="showWarningModal"
        :title="__('messages.warning')"
        :message="__('products.productPrices.form.exceed_limited_runtime')"
        is-confirm
        is-error
        @close="showWarningModal = false"
        @confirm="$emit('form-submitted', form)"
    />
</template>

<script>

export default {
    name: 'ProductPriceForm',
    props: {
        productPrice: {
            type: Object,
            default: () => { return {} }
        },
        productPlan: {
            type: Object,
            default: () => { return {} }
        },
        billingCycles: {
            type: Array,
            default: () => { return [] }
        },
        contractTermUnits: {
            type: Array,
            default: () => { return [] }
        },
        discountTypes: {
            type: Array,
            default: () => { return [] }
        },
        productId: {
            type: Number,
            default: 0
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        isAddon: {
            type: Boolean,
            default () {
                return false
            }
        },
        currency: {
            type: String,
            default: null
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            showWarningModal: false,
            form: this.$inertia.form({
                price: this.productPrice?.price ?? null,
                third_party_cost: this.productPrice?.third_party_cost ?? null,
                billing_cycle: this.productPrice?.billing_cycle ?? null,
                setup_fee: this.productPrice?.setup_fee ?? null,
                valid_from_month: this.productPrice?.valid_from_month ?? null,
                contract_term: this.productPrice?.contract_term ?? null,
                contract_term_unit: this.productPrice?.contract_term_unit ?? null,
                notice_period: this.productPrice?.notice_period ?? null,
                notice_period_unit: this.productPrice?.notice_period_unit ?? null,
                discount_name: this.productPrice?.discount_name ?? null,
                discount_type: this.productPrice?.discount_type ?? null,
                discount_value: this.productPrice?.discount_value ?? null,
                is_create: Object.keys(this.productPrice).length === 0,
                activity_log_comment: null
            })
        }
    },
    methods: {
        submitForm () {
            if (this.productPlan.runtime === 'limited' && this.form.valid_from_month > this.productPlan.runtime_in_month) {
                this.showWarningModal = true
                return
            }
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
